import { render, staticRenderFns } from "./ListAlbaranPage.vue?vue&type=template&id=2ec8eba2"
import script from "./ListAlbaranPage.vue?vue&type=script&lang=js"
export * from "./ListAlbaranPage.vue?vue&type=script&lang=js"
import style0 from "./ListAlbaranPage.vue?vue&type=style&index=0&id=2ec8eba2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports